// ─── Hook ─────────────────────────────────────────────────────────────────────

import { useGetApiV1AccesscontrolControllers } from '@/shared/api/generated';

/**
 * Hook para listar todos os controllers disponíveis.
 *
 * @returns Lista de controllers com estado de loading/error
 *
 * @example
 * ```tsx
 * const { controllers, isLoading } = useControllerList();
 * ```
 */
export function useControllerList() {
  const query = useGetApiV1AccesscontrolControllers();

  return {
    controllers: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
